import { render } from "./ReportDiseaseModal.vue?vue&type=template&id=5ca141da&scoped=true"
import script from "./ReportDiseaseModal.vue?vue&type=script&lang=js"
export * from "./ReportDiseaseModal.vue?vue&type=script&lang=js"

import "./ReportDiseaseModal.vue?vue&type=style&index=0&id=5ca141da&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca141da"]])

export default __exports__